const currency = "USD";
const language = "en-Us";
const apiUrl = "http://localhost:7084";
export { currency, language, apiUrl };
